import { Action, ActionReducer } from '@ngrx/store';
import { User } from '../models/user';
import { AppActions, AppActionTypes } from './app.actions';

export interface State {
  app: AppState;
}

export interface AppState {
  currentUser: User;
}

const initialState: AppState = {
  currentUser: new User()
};

/**
 * Reducer for the `app` feature. The action parameter is widened to
 * `Action | AppActions` so this function is directly compatible with both:
 *   - `StoreModule.forRoot({ app: appReducer })`, which expects an
 *     `ActionReducer<…, Action>`, and
 *   - direct use inside the app where discriminated-union narrowing on
 *     `AppActions` is still useful.
 */
export function appReducer(state: AppState = initialState, action: Action | AppActions): AppState {
  switch (action.type) {
    case AppActionTypes.ToggleCurrentUser:
      return { ...state, currentUser: (action as AppActions).payload };
    default:
      return state;
  }
}

/**
 * Convenience alias matching NgRx's `ActionReducer` contract.
 */
export type AppReducer = ActionReducer<AppState, Action>;

